import { render, staticRenderFns } from "./partsRowTable.vue?vue&type=template&id=85604ffc&scoped=true&"
import script from "./partsRowTable.vue?vue&type=script&lang=js&"
export * from "./partsRowTable.vue?vue&type=script&lang=js&"
import style0 from "./partsRowTable.vue?vue&type=style&index=0&id=85604ffc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85604ffc",
  null
  
)

export default component.exports